import React from 'react'
// libs
import { useDispatch } from 'react-redux'
// redux
import { hideModal as hideModalAction } from 'store/reducers/modals'
// hocs
import withObjective from 'components/Modals/PlanItems/Objective/withObjective'
// hooks
import { useModalData } from 'hooks'
// components
import { Tab } from '@mui/material'
import { LoaderWithOverlay, Scrollbar, Tabs } from 'components/UI'
import { PlanObjectiveActionsMenu } from 'components/CTAs'
import FullModalContainer from '../../components/FullModalContainer'
// view components
import CompleteReviewContainer from 'containers/Review/CompleleReview'
import CompleteAction from 'components/Modals/PlanItems/Action/MinimizedModal/components/DetailsSection/components/CompleteAction'
import DetailsSection from 'components/Modals/PlanItems/Objective/MinimizedModal/components/DetailsSection'
import ObjectiveActivitiesList from 'components/Modals/PlanItems/Objective/MinimizedModal/components/ActivitiesList'
import ObjectiveResourcesList from 'components/Modals/PlanItems/Objective/MinimizedModal/components/ResourcesList'
import ObjectiveReviewsList from 'components/Modals/PlanItems/Objective/MinimizedModal/components/ReviewsList'
// constants
import { Modals, ENTITIES } from 'constants/index'
// views
import {
  SubHeader,
  ContentWrapper,
  FormWrapper,
  DetailsWrapper,
  FullModalHeader as Header,
  ActivitiesWrapper,
  CollapseIcon
} from 'components/Modals/PlanItems/styles'
// themes
import { CloseIcon } from 'components/UI/Icons'
import { EllipsizedText } from 'themes/views/generic'
// context
import { ObjectiveContext } from 'context'
// utils
import { safeGetOr } from 'utils/fp'

const ObjectiveFullModal = () => {
  const dispatch = useDispatch()

  const { hideModal, modalData } = useModalData({ modalType: Modals.OBJECTIVE_FULL_MODAL })

  const { entity, isLoading, plan, update } = React.useContext(ObjectiveContext)

  const [tab, setTab] = React.useState(0)
  const [isReviewExist, setIsReviewExist] = React.useState(false)

  const { width, isOpen } = modalData

  const isActionExist = safeGetOr('', 'completionAt')(entity)

  const scrollbarHeight = React.useMemo(() => {
    if (isReviewExist && isActionExist) {
      return 'calc(100% - 164px)'
    }
    if (isReviewExist || isActionExist) {
      return 'calc(100% - 82px)'
    }
    return '100%'
  }, [isReviewExist, isActionExist])

  const handleSetIsReviewExist = (value) => setIsReviewExist(value)

  const handleClose = () => {
    dispatch(hideModalAction(Modals.OBJECTIVE_MINIMIZED_MODAL))
    dispatch(hideModalAction(Modals.OBJECTIVE_FULL_MODAL))
  }

  const handleSetTab = (_, value) => setTab(value)

  return (
    <FullModalContainer hideModal={hideModal} isOpen={isOpen} width={width}>
      <LoaderWithOverlay isLoading={isLoading} />
      {!isLoading && (
        <>
          <Header>
            <EllipsizedText style={{ maxWidth: '95%' }}>{entity.description}</EllipsizedText>
            <CollapseIcon onClick={hideModal} />
            <CloseIcon onClick={handleClose} />
          </Header>
          <ContentWrapper>
            <FormWrapper>
              <CompleteAction isFullModal isPlanObjective entity={entity} update={update} />
              <CompleteReviewContainer
                entity={{ ...entity, entityType: ENTITIES.PLAN_OBJECTIVE }}
                handleOnMount={handleSetIsReviewExist}
                hideModal={hideModal}
                isFullModal
              />
              <Scrollbar style={{ height: scrollbarHeight }}>
                <DetailsSection hideModal={hideModal} disableDrag isFullModal />
              </Scrollbar>
            </FormWrapper>
            <DetailsWrapper>
              <SubHeader>
                {!plan.locked && <PlanObjectiveActionsMenu plan={plan} entity={entity} hideParent={hideModal} />}
                <Tabs value={tab} onChange={handleSetTab} indicatorColor='primary' textColor='primary' variant={null}>
                  <Tab label='Activity' />
                  <Tab label='Resources' />
                  <Tab label='Reviews' />
                </Tabs>
              </SubHeader>
              {tab === 0 && (
                <ActivitiesWrapper>
                  <ObjectiveActivitiesList />
                </ActivitiesWrapper>
              )}
              {tab === 1 && <ObjectiveResourcesList />}
              {tab === 2 && <ObjectiveReviewsList />}
            </DetailsWrapper>
          </ContentWrapper>
        </>
      )}
    </FullModalContainer>
  )
}

export default withObjective(ObjectiveFullModal)
